/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  title: 'Registration',
  appTitle: 'Rawam',

  nameAr: 'Arabic Name',
  nameEn: 'English Name',

  email: 'Email',
  username: 'Username',
  password: 'Password',
  confirmPassword: 'Confirm Password',

  alreadyRegistered: 'Already have an account? login now',
  submitting: 'Please wait...',
  close: 'Close',

  messages: {
    required: 'Field required',
    length: 'Text must be with in 3 to 200 letters.',
    emailRequired: 'E-mail is required.',

    emailInvalid: 'Please enter a valid e-mail address.',

    passwordMismatch: 'The Password and Confirmation Password must match.',

    accountCreated: 'Your account has been successfully created.',

    duplicateUsername: 'Duplicated username please select another one',

    duplicateEmail: 'Duplicated email please select another one',

    passwordPolicy:
      'password must be between 6 and 15 characters, contain at least one digit and one special characters.',

    systemError: 'A system error occurred, please try again',
  },

  closedTitle: 'Registration unavailable',
  backToLogin: 'Back to login',

  logoAlt: 'Rawam',
}

export const activateStrings = {
  title: 'Activate User account',
  logout: 'Logout',

  states: {
    waitingUser:
      'Hello, an email has been sent to you containing an activation link. Please click on it to activate your account',

    waitingAdmin: 'Welcome your account now is waiting for approval from the system\'s administrator',

    expired: 'Your account has been expired',
    resigned: 'Account\'s user has been resigned',
    suspended: 'Your account has been Suspended',
  },

  confirmFailed: 'The account could not be activated, please check the link or contact the system administrator',
  goToLogin: 'Go to login',
}
